import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseAuthCodeData } from './ConfigData'
import { AuthCodeSettings } from './Settings'

interface AutCodeComponent extends CustomComponentEnhanced<AuthCodeSettings> {}

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch =
    useUpdateCustomComponent<AuthCodeSettings>(componentID)
  const currentSemanticSearch =
    useGetCustomComponent<AuthCodeSettings>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseAuthCodeData
  )
  const parseData = (data?: AutCodeComponent | null): AutCodeComponent => {
    if (!data) return {} as AutCodeComponent
    return pick(
      ['name', 'description', 'settings', 'type'],
      data
    ) as AutCodeComponent
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data as unknown as AutCodeComponent)
    if (!restoredData) return
    await updateSemanticSearch.mutateAsync(restoredData)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
